import type { ProfileConfig } from "./types";

export const albertineProfileConfig: ProfileConfig = {
    benefits: null,
};
